'use strict';
import $ from 'jquery'
import autosize from 'autosize'
import select2 from 'select2'
select2($);

/*
 * Eventos Turbo
 */
document.addEventListener('turbo:load', vendor_init);
document.addEventListener('turbo:render', vendor_init);

function initTooltipsAndPopovers() {
  /*------------------------------------------------
      Popovers (Bootstrap 5)
  -------------------------------------------------*/
  const popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"], [data-toggle="popover"]'));
  popoverTriggerList.forEach((popoverTriggerEl) => {
    // eslint-disable-next-line no-undef
    new bootstrap.Popover(popoverTriggerEl);
  });

  /*------------------------------------------------
      Tooltip (Bootstrap 5)
  -------------------------------------------------*/
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"], [data-toggle="tooltip"], a[title]:not([data-bs-toggle]):not([data-toggle]), b[title], span[title]'));
  tooltipTriggerList.forEach((tooltipTriggerEl) => {
    // eslint-disable-next-line no-undef
    const tooltip = new bootstrap.Tooltip(tooltipTriggerEl, { trigger: 'hover' });

    // Fechar tooltip no clique para evitar que fique preso
    tooltipTriggerEl.addEventListener('click', () => tooltip.hide());
  });
}

function vendor_init() {
  /*------------------------------------------------
      Autosize Textarea
  ------------------------------------------------*/
  const textareas = document.querySelectorAll('.textarea-autosize');
  if (textareas.length) {
    autosize(textareas);
  }

  initTooltipsAndPopovers();

  /*------------------------------------------------
      Toggle visibilidade de senha
  ------------------------------------------------*/
  initPasswordToggle();

  /*------------------------------------------------
      Auto dismiss Alerts
      Apenas alerts com .alert-dismissible ou [data-bs-auto-dismiss]
  ------------------------------------------------*/
  document.querySelectorAll('.alert.alert-dismissible, .alert[data-bs-auto-dismiss]').forEach((alertEl) => {
    const delay = parseInt(alertEl.getAttribute('data-bs-auto-dismiss') || '4000', 10);

    // Define variável CSS para animar barra de progresso
    alertEl.style.setProperty('--alert-duration', `${delay}ms`);

    // Se ainda não houver barra de progresso, cria
    if (!alertEl.querySelector('.alert-progress')) {
      const bar = document.createElement('div');
      bar.className = 'alert-progress';
      alertEl.appendChild(bar);
    }

    setTimeout(() => {
      // eslint-disable-next-line no-undef
      const bsAlert = new bootstrap.Alert(alertEl);
      bsAlert.close();
    }, delay);
  });
}

function initPasswordToggle() {
  const toggles = document.querySelectorAll('.toggle-password');
  toggles.forEach((toggle) => {
    const targetId = toggle.getAttribute('data-target');
    const input = document.getElementById(targetId);
    if (!input) return;

    toggle.addEventListener('click', () => {
      const isPassword = input.getAttribute('type') === 'password';
      input.setAttribute('type', isPassword ? 'text' : 'password');

      const icon = toggle.querySelector('i') || toggle; // Caso o <i> esteja dentro ou seja o próprio elemento
      if (isPassword) {
        icon.classList.remove('zmdi-eye-off');
        icon.classList.add('zmdi-eye');
      } else {
        icon.classList.remove('zmdi-eye');
        icon.classList.add('zmdi-eye-off');
      }
    });
  });
}

/*
 * Antes de enviar a página para o cache (Turbo), destrói tooltips/popovers existentes
 */
document.addEventListener('turbo:before-cache', () => {
  // eslint-disable-next-line no-undef
  const tooltipList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'));
  tooltipList.forEach((el) => {
    if (bootstrap.Tooltip.getInstance(el)) {
      bootstrap.Tooltip.getInstance(el).dispose();
    }
  });

  const popoverList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  popoverList.forEach((el) => {
    if (bootstrap.Popover.getInstance(el)) {
      bootstrap.Popover.getInstance(el).dispose();
    }
  });
});